'use client'

// eslint-disable-next-line rulesdir/require-next-link-wrapper
import NextLink, { type LinkProps } from 'next/link'
import { type AnchorHTMLAttributes, type ReactNode, RefAttributes } from 'react'
import styled from 'styled-components'

import { focusOutline, focusOutlineInset } from '@syconium/little-miss-figgy'

type StyledNextLinkProps = {
  $insetFocusOutline?: boolean
  $display?: 'inline-block' | 'block'
}

export type NextLinkProps = LinkProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & {
    children?: ReactNode
  } & StyledNextLinkProps &
  RefAttributes<HTMLAnchorElement>

const StyledNextLink = styled(NextLink)<StyledNextLinkProps>`
  ${o => (o.$insetFocusOutline ? focusOutlineInset : focusOutline)}
  ${o => (o.$display === 'inline-block' || o.$display === 'block' ? 'line-height: 0px;' : null)}
  ${o => (o.$display ? `display: ${o.$display};` : null)}
`

const LinkNoPrefetch = function LinkWithRef({
  // Turn next/link prefetching off by default.
  // @see https://github.com/vercel/next.js/discussions/24009
  prefetch = false,
  href: hrefProp,
  ref,
  ...rest
}: NextLinkProps) {
  const href = typeof hrefProp === 'string' ? hrefProp.trim() : hrefProp
  return <StyledNextLink prefetch={prefetch} {...rest} href={href} ref={ref} />
}

export { LinkNoPrefetch as NextLink }
